/**
 * Hook: is the current user an invoice approver?
 *
 * Approver = hub admin OR tools.invoices.role in ('approver', 'admin').
 * This mirrors the server-side `isApprover` check in functions/src/invoices/auth.ts
 * and the rules-side `isInvoiceApprover()` function. We compute it client-side
 * for UI gating only — actual authorization happens in the callable.
 */

import { useProfile } from '../../profile/ProfileProvider';

export function useIsInvoiceApprover(): boolean {
  const { state } = useProfile();
  if (state.status !== 'ready') return false;

  const myEmail = state.user.email.toLowerCase();
  const hubAdmins =
    state.config.hubAdminEmails?.map((e) => e.toLowerCase()) ?? [];
  if (hubAdmins.includes(myEmail)) return true;

  const tool = state.user.tools?.invoices;
  if (!tool?.enabled) return false;
  return tool.role === 'approver' || tool.role === 'admin';
}
